import styled from 'styled-components';
import { Heading as PPHeading } from 'prospect-path-components';

const Heading = styled(PPHeading)`
  font-size: 2rem;
  margin: 0;
`;

export default Heading;

